import { useTranslation } from 'react-i18next';

import NumberTicker from '@/components/effects/NumberTicker';

/**
 * Trust strip directly under the Home hero. Two NumberTicker stats animate
 * from 0 → target on scroll. Third slot is a small editorial label
 * ("Écrit depuis Panama City").
 *
 * @param {object} props
 * @param {string} [props.className]
 *
 * @example
 *   <TrustBand className="mt-6" />
 */
export default function TrustBand({ className = '' }) {
  const { t } = useTranslation('pages');

  return (
    <div
      className={`grid grid-cols-3 gap-4 border-y border-navy-900/10 py-5 sm:gap-8 ${className}`}
    >
      {/* Stat 1 — readers */}
      <div>
        <p className="font-mono text-2xl font-semibold tabular-nums text-navy-900 sm:text-3xl">
          <NumberTicker value={12000} suffix="+" />
        </p>
        <p className="mt-1.5 text-[11px] font-medium uppercase tracking-eyebrow text-gray-700">
          {t('home.trust.readersLabel', { defaultValue: 'Lecteurs / mois' })}
        </p>
      </div>

      {/* Stat 2 — subscribers */}
      <div>
        <p className="font-mono text-2xl font-semibold tabular-nums text-navy-900 sm:text-3xl">
          <NumberTicker value={3000} />
        </p>
        <p className="mt-1.5 text-[11px] font-medium uppercase tracking-eyebrow text-gray-700">
          {t('home.trust.subsLabel', { defaultValue: 'Abonnés newsletter' })}
        </p>
      </div>

      {/* Slot 3 — editorial signature, full width on mobile */}
      <div className="col-span-3 flex items-center sm:col-span-1">
        <p className="font-serif italic text-base text-navy-800 sm:text-lg">
          {t('home.trust.c', { defaultValue: 'Écrit depuis Panama City' })}
        </p>
      </div>
    </div>
  );
}
